// extracted by mini-css-extract-plugin
export default {"appointment_booking":"AppointmentBookingSpec_appointment_booking__Ixpwh"};